import { Card } from "antd";
import Master from "../../assets/icons/mastercard.svg";

const MasterCard = ({ last4, date }) => {
  return (
    <Card className={`bg-visaSecondary w-24.6 h-8.7 `}>
      <div className="flex flex-col  ml-1">
        <img src={Master} alt="Master Icon" className="w-6 h-2 mt-1" />
        <div className="flex justify-between ">
          <p className="text-white text-base mt-0.5">Ending in **** {last4}</p>
          <p className="text-white text-base mr-1">{date}</p>
        </div>
      </div>
    </Card>
  );
};
export default MasterCard;
